import { useEffect, useRef } from 'react';
import 'swiper/css'; // core Swiper
import "swiper/css/effect-fade"; 
import 'swiper/css/pagination'; // Pagination module
import { register } from 'swiper/element/bundle';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

export function Slider(props) {
  const swiperRef = useRef(null);
  const {
    children,
    ...rest
  } = props;

  useEffect(() => {
    // Register Swiper web component
    register();

    // pass component props to parameters
    const params = {
      ...rest,
      modules: [Navigation, Pagination, Autoplay, EffectFade]
    };

    // Assign it to swiper element
    Object.assign(swiperRef.current, params);
    
    // initialize swiper  
    swiperRef.current.initialize();
  }, []);

  return (
      <div className='slider_container'>
          <swiper-container init="false" ref={swiperRef} >
            {children}
          </swiper-container>
          <div className='testimonial-pagination'>

          </div>
          <button className="slider_button button-prev-custom">
            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30 17H11.745L20.13 8.615L18 6.5L6 18.5L18 30.5L20.115 28.385L11.745 20H30V17Z" fill="#E8236B"/>
            </svg>
          </button>
          <button className="slider_button button-next-custom">
            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6.5L15.885 8.615L24.255 17H6V20H24.255L15.885 28.385L18 30.5L30 18.5L18 6.5Z" fill="#E8236B"/>
            </svg>
          </button>
      </div>
    );

}

export function Slide(props) {
  const {
    children,
    className,
    ...rest
  } = props;

  return (
    <swiper-slide  class={className} {...rest}>
      {children}
    </swiper-slide>
  );
}